import script from "./PinComment.vue?vue&type=script&setup=true&lang=js"
export * from "./PinComment.vue?vue&type=script&setup=true&lang=js"

import "./PinComment.vue?vue&type=style&index=0&id=4978a806&lang=scss"

const __exports__ = script;

export default __exports__